import React from 'react';
import { formatMoney } from '../../util/currency';
import { intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const DISCOUNT_PREFIX = 'line-item/discount-';

const LineItemDiscountMaybe = ({ lineItems, intl }) => {
  const discountItem = lineItems.find(
    item => item.code.startsWith(DISCOUNT_PREFIX) && !item.reversal
  );

  if (!discountItem) return null;

  const codeName = discountItem.code.replace(DISCOUNT_PREFIX, '').toUpperCase();
  const formattedTotal = formatMoney(intl, discountItem.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>Discount - {codeName}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

LineItemDiscountMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemDiscountMaybe;
